
import React, { useEffect, useState } from "react";
import { TableBody } from "@/components/ui/table";
import TablePointRow from "./TablePointRow";
import TableTotalRow from "./TableTotalRow";
import { isIronTest, isDriverTest, isWedgingTest } from "../../level3/scoring/utils";

interface ScoresState {
  [key: string]: (number | null)[];
}

interface LevelInfo {
  level: string;
}

interface StandardTableBodyProps {
  testPoints: string[];
  scores: ScoresState;
  isSpecialPutts: boolean;
  getPointTotal: (point: string) => number;
  getGrandTotal: () => number;
  getTestDistances: (testId: string) => Record<string, string>;
  selectedTest: string | null;
  levels: Record<string, string | LevelInfo>;
  isWedgingTest?: boolean;
  isBunkerTest?: boolean;
  isIronTest?: boolean;
  isDriverTest?: boolean;
}

const StandardTableBody: React.FC<StandardTableBodyProps> = ({
  testPoints,
  scores,
  getPointTotal,
  getGrandTotal,
  getTestDistances,
  selectedTest,
  levels,
  isWedgingTest: propIsWedgingTest = false,
  isBunkerTest = false,
  isIronTest: propIsIronTest = false,
  isDriverTest: propIsDriverTest = false
}) => {
  const [displayPoints, setDisplayPoints] = useState<string[]>([]);
  
  // We're explicitly in level 2 here
  const currentLevel = 2;
  
  console.log("Level 2 StandardTableBody - testPoints:", testPoints);
  console.log("Level 2 StandardTableBody - isWedgingTest:", propIsWedgingTest);
  
  useEffect(() => {
    if (testPoints && testPoints.length > 0) {
      setDisplayPoints([...testPoints]);
    }
  }, [testPoints]);

  return (
    <TableBody>
      {displayPoints.map((point) => (
        <TablePointRow
          key={point}
          point={point}
          scores={scores}
          selectedTest={selectedTest}
          getPointTotal={getPointTotal}
          getTestDistances={getTestDistances}
          isWedgingTest={propIsWedgingTest || (selectedTest && isWedgingTest(selectedTest))}
          isBunkerTest={isBunkerTest}
          isIronTest={propIsIronTest || (selectedTest && isIronTest(selectedTest))}
          isDriverTest={propIsDriverTest || (selectedTest && isDriverTest(selectedTest))}
        />
      ))}
      <TableTotalRow getGrandTotal={getGrandTotal} />
    </TableBody>
  );
};

export default StandardTableBody;
